import { DialogOptions } from '../../../models/modal.model'
import {
  NotificationOptions,
  parseGenericNotification,
} from '../../../models/notification.model'
import { Role } from '../models/role.entity'

export type RoleNotificationCode =
  | 'ROLE_DELETED'
  | 'ROLE_SAVED'
  | 'UNABLE_TO_SAVE_PERMISSIONS'

export type RoleModalCode = 'ROLE_DELETION'

/**
 * Parse role code to a notification
 * @param code - the role notification code
 * @returns the notification options
 */
export function parseRoleNotification(
  code?: RoleNotificationCode,
): NotificationOptions {
  switch (code) {
    case 'ROLE_DELETED':
      return {
        message: 'Role deleted successfully',
        color: 'success',
      }
    case 'ROLE_SAVED':
      return {
        message: 'Role saved successfully',
        color: 'success',
      }
    case 'UNABLE_TO_SAVE_PERMISSIONS':
      return {
        message: 'There was an error trying to save permissions',
        color: 'error',
      }
    default:
      return parseGenericNotification(code)
  }
}

/**
 * Parse role code to an modal
 * @param code - the role modal code
 * @param role - the role object
 * @returns the modal settings
 */
export function parseRoleModal(
  code: RoleModalCode,
  role?: Role,
): DialogOptions {
  switch (code) {
    case 'ROLE_DELETION': {
      const roleLabel = role?.label
      return {
        title: 'Delete role',
        message:
          'You are about to delete the role <strong>%s</strong>. Proceed with deletion?',
        messageParams: roleLabel ? [roleLabel] : undefined,
        buttons: ['Cancel', 'Confirm'],
      }
    }
    default:
      return {}
  }
}
